import {
  Typography,
  Col,
  Checkbox,
  Flex,
  Grid,
  Input,
  DatePicker,
  Select,
} from "antd";
import InputNumberField from "../Input/InputNumber";
import ChequePayment from "../Payment/ChequePayment";
import EmiPayment from "../Payment/EmiPayment";
import { calculateTotals } from "../../utils/sale";
import NormalPayment from "../Payment/NormalPayment";
import AddExpenses from "../Payment/AddExpenses";
import dayjs from "dayjs";
import { getCurrencySymbol } from "../../lib/currency";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setPatientCopayPercent,
  setInsuranceCompanyId,
  setSelectedDoctorId,
  setShowDoctorField,
  recalcPatientAmounts,
  setDeliveryType,
} from "../../pages/SalesPharma/salesSlice";

const { Text } = Typography;
const { useBreakpoint } = Grid;

const DataTableFooter = ({
  footerValues,
  taxMode,
  onFooterChange,
  dataSource,
  defaultAccount,
  pageType,
  conversionRate,
  dueDate,
  authInfo,
  editId
}) => {
  const screens = useBreakpoint();
  const isMobile = !screens.md || !screens.xl; // Adjust the breakpoint as per requirement
  const { dueAmount, grandTotal, totalSubtotal } = calculateTotals(
    taxMode,
    dataSource,
    footerValues
  );

  // const symbol = getCurrencySymbol(authInfo?.currency);
  const symbol = getCurrencySymbol(
    conversionRate ? footerValues?.conversion_currency : authInfo?.currency
  );

  const dispatch = useDispatch();
  const delivery_models = ["Walkin", "Home Delivery"];

  const deliveryOptions = delivery_models.map((m) => ({
    label: m.trim(),
    value: m.trim(),
  }));
  // redux patient state
  const patients = useSelector((s) => s.salesPharma.patientsList || []);
  const doctors = useSelector((s) => s.salesPharma.doctorsList || []);
  const insuranceCompanies = useSelector(
    (s) => s.salesPharma.insuranceCompanies || []
  );
  const patientCopayPercent = useSelector(
    (s) => s.salesPharma.patientCopayPercent || 0
  );
  const insuranceCompanyId = useSelector(
    (s) => s.salesPharma.insuranceCompanyId
  );
  const selectedDoctorId = useSelector((s) => s.salesPharma.selectedDoctorId);
  const showDoctorField = useSelector((s) => s.salesPharma.showDoctorField);
  const patientDueAmount = useSelector(
    (s) => s.salesPharma.patientDueAmount || 0
  );
  const insuranceDueAmount = useSelector(
    (s) => s.salesPharma.insuranceDueAmount || 0
  );
  const deliveryType = useSelector((state) => state.salesPharma.deliveryType);

  useEffect(() => {
    if (authInfo.branch_company_type === "Pharmacy" && grandTotal) {
      dispatch(
        recalcPatientAmounts({
          grandTotal,
        })
      );
    }
  }, [grandTotal, patientCopayPercent, insuranceCompanyId, pageType, dispatch]);

  const getDueDateValue = (dueDate) => {
    if (!dueDate) {
      // No due date at all → show empty
      return null;
    }

    // Try parsing known formats
    const parsed =
      dayjs(dueDate, ["YYYY-MM-DD", "DD-MM-YYYY"], true);

    if (!parsed.isValid()) {
      // Invalid date → show today
      return dayjs();
    }

    return parsed;
  };

  const effectiveDueAmount =
    (authInfo.branch_company_type === "Pharmacy" && insuranceCompanyId)
      ? patientDueAmount - (footerValues?.paidAmount || 0)
      : dueAmount;

  // const showChequePayment =
  //   pageType !== "salesReturn" &&
  //   (footerValues?.paymentMode?.includes("isCheque") ||
  //     Number(footerValues?.paidAmount) > 0);
  const showChequePayment = Boolean(
    pageType !== "salesReturn" &&
    (footerValues?.paymentMode?.includes("isCheque") ||
      Number(footerValues?.paidAmount) > 0 ||
      footerValues?.payCart)
  );

  return (
    <Flex
      gap={10}
      style={{
        width: "100%",
        flexDirection: isMobile ? "column-reverse" : "row",
      }}
    >
      <Flex
        vertical
        gap={5}
        style={{
          width: isMobile ? "100%" : "50%",
        }}
      >
        <Flex
          style={{
            marginTop: "32px",
            marginBottom: "32px",
          }}
        >
          <Col
            style={{
              width: "100%",
            }}
          >
            {pageType !== "salesReturn" && (
              <Checkbox.Group
                value={footerValues?.paymentMode || []}
                onChange={(value) => onFooterChange(value, "paymentMode")}
                options={[
                  {
                    label: "EMI Payment",
                    value: "isEmi",
                  },
                  {
                    label: "Payment",
                    value: "isCheque",
                  },
                  {
                    label: "Additional Expenses",
                    value: "addExpenses",
                  },
                ]}
              />
            )}
          </Col>
        </Flex>

        {footerValues?.paidAmount > 0 && pageType !== "sales" && (
          <NormalPayment
            onFooterChange={onFooterChange}
            defaultAccount={defaultAccount}
            value={footerValues?.payCart}
          />
        )}
        {showChequePayment && (
          <ChequePayment
            onFooterChange={onFooterChange}
            defaultAccount={defaultAccount}
            footerValues={footerValues}
            conversionRate={conversionRate}
          />
        )}
        {/* {pageType !== "salesReturn" &&
          footerValues?.paymentMode?.includes("isCheque") && (
            <ChequePayment
              onFooterChange={onFooterChange}
              defaultAccount={defaultAccount}
              footerValues={footerValues}
            />
          )} */}

        {footerValues?.paymentMode?.includes("isEmi") &&
          pageType !== "salesReturn" && (
            <EmiPayment
              onFooterChange={onFooterChange}
              salesVoucherNumber={footerValues?.salesVoucherNumber}
              dueAmount={dueAmount}
              conversionRate={conversionRate}
              emis={footerValues?.emis || []}
              emiMonths={footerValues?.emiMonths || 0}
              emiAmount={footerValues?.emiAmount || 0}
              emiDayWeek={footerValues?.emiDayWeek || "0"}
              isEditMode={!!editId} // This is crucial for edit mode
            />
          )}
        {footerValues?.paymentMode?.includes("addExpenses") && (
          <AddExpenses
            onFooterChange={onFooterChange}
            servicePayCart={footerValues?.payServiceCart || []}
            conversionRate={conversionRate}
          />
        )}
      </Flex>
      <Flex
        gap={10}
        vertical
        style={{
          width: isMobile ? "100%" : "50%",
        }}
      >
        <Flex justify="space-between" align="center" gap={60}>
          <Col
            style={{
              width: "50%",
            }}
          >
            <Text
              level={5}
              style={
                {
                  // fontWeight: 500,
                }
              }
            >
              Subtotal :
            </Text>
          </Col>
          <Col
            style={{
              width: "19%",
            }}
          >
            <Text
              level={5}
              style={
                {
                  // fontWeight: 500,
                }
              }
            >
              {symbol}
              {parseFloat(
                conversionRate ? totalSubtotal * conversionRate : totalSubtotal
              )?.toFixed(2)}
            </Text>
          </Col>
        </Flex>

        {taxMode === "on_total" && (
          <>
            <Flex justify="space-between" align="center" gap={50}>
              <Col
                style={{
                  width: "50%",
                }}
              >
                <Text
                  level={5}
                  style={
                    {
                      // fontWeight: 500,
                    }
                  }
                >
                  Discount :
                </Text>
              </Col>
              <Col
                style={{
                  width: "19%",
                }}
              >
                <InputNumberField
                  min={0}
                  max={100}
                  type="number"
                  precision={2}
                  value={parseFloat(footerValues.discountPercent)?.toFixed(2)}
                  onChange={(value) => {
                    onFooterChange(value, "discountPercent");
                  }}
                  suffix="%"
                  style={{ width: "100%" }}
                />
              </Col>
            </Flex>
            {(authInfo?.country?.toLowerCase() !== "india" || authInfo?.gst_enabled === "yes") && (
              <Flex justify="space-between" align="center" gap={50}>
                <Col
                  style={{
                    width: "50%",
                  }}
                >
                  <Text
                    level={5}
                    style={
                      {
                        // fontWeight: 500,
                      }
                    }
                  >
                    {authInfo?.country?.toLowerCase() === "india"
                      ? "GST :"
                      : "VAT :"}
                  </Text>
                </Col>
                <Col
                  style={{
                    width: "19%",
                  }}
                >
                  <InputNumberField
                    min={0}
                    max={100}
                    precision={2}
                    value={parseFloat(footerValues.taxPercent)?.toFixed(2)}
                    onChange={(value) => onFooterChange(value, "taxPercent")}
                    suffix="%"
                    style={{ width: "100%" }}
                    disabled
                  />
                </Col>
              </Flex>
            )}
          </>
        )}

        {authInfo.branch_company_type === "Pharmacy" && insuranceCompanyId && (
          <div
            style={{
              marginBottom: 16,
              border: "1px solid #eee",
              padding: 12,
              borderRadius: 6,
            }}
          >
            {/* Grid Wrapper for responsive layout */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr",
                gap: 16,
                marginTop: 12,
              }}
              className="responsive-grid" // optional class for media query override
            >
              {/* Insurance selector */}
              <div>
                <Text>Insurance</Text>
                <Select
                  showSearch
                  style={{ width: "100%", marginTop: 6 }}
                  placeholder="Select insurance company"
                  value={insuranceCompanyId || undefined}
                  onChange={(val) => {
                    dispatch(setInsuranceCompanyId(val || null));
                  }}
                  options={insuranceCompanies.map((ic) => ({
                    label: ic.company_name,
                    value: ic.ic_id,
                  }))}
                  allowClear
                />
              </div>

              {/* Co-pay % */}
              <div>
                <Text>Co-pay %</Text>
                <InputNumberField
                  min={0}
                  max={100}
                  precision={2}
                  value={patientCopayPercent}
                  onChange={(v) =>
                    dispatch(setPatientCopayPercent(Number(v || 0)))
                  }
                  style={{ width: "100%", marginTop: 6 }}
                  suffix="%"
                />
              </div>

              {/* Doctor selection */}
              <div>
                <Text>Doctor</Text>
                <Select
                  data-testid="doctor-select"
                  showSearch
                  style={{ width: "100%", marginTop: 6 }}
                  placeholder="Select Doctor"
                  value={selectedDoctorId || undefined}
                  onChange={(val) => dispatch(setSelectedDoctorId(val || null))}
                  options={doctors.map((d) => ({
                    label: d.doctor_name,
                    value: d.id || d.doctor_id,
                  }))}
                  allowClear
                />
              </div>

              {/* Delivery Type */}
              <div>
                <Text>Delivery Type</Text>
                <Select
                  data-testid="delivery-type-select"
                  style={{ width: "100%", marginTop: 6 }}
                  placeholder="Select Delivery Type"
                  value={deliveryType || undefined}
                  onChange={(val) => dispatch(setDeliveryType(val))}
                  options={deliveryOptions}
                  allowClear={true}
                />
              </div>
            </div>

            {/* Patient / Insurance computed amounts (read-only) */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr",
                gap: 16,
                marginTop: 20,
              }}
              className="responsive-grid"
            >
              <div>
                <Text>Patient Amount</Text>
                <div style={{ marginTop: 6 }}>
                  <Text>
                    {symbol}
                    {(conversionRate
                      ? (patientDueAmount * conversionRate).toFixed(2)
                      : patientDueAmount?.toFixed(2)) || "0.00"}
                  </Text>
                </div>
              </div>

              <div>
                <Text>Insurance Due</Text>
                <div style={{ marginTop: 6 }}>
                  <Text>
                    {symbol}
                    {(conversionRate
                      ? (insuranceDueAmount * conversionRate).toFixed(2)
                      : insuranceDueAmount?.toFixed(2)) || "0.00"}
                  </Text>
                </div>
              </div>
            </div>
          </div>
        )}

        {pageType === "service" && (
          <Flex justify="space-between" align="center" gap={50}>
            <Col
              style={{
                width: "50%",
              }}
            >
              <Text
                level={5}
                style={
                  {
                    // fontWeight: 500,
                  }
                }
              >
                Service Charge :
              </Text>
            </Col>

            <Col
              style={{
                width: "19%",
              }}
            >
              <InputNumberField
                min={0}
                precision={2}
                value={parseFloat(
                  conversionRate
                    ? footerValues?.serviceCharge * conversionRate
                    : footerValues?.serviceCharge
                )}
                onChange={(value) => {
                  const originalRate = conversionRate
                    ? value / conversionRate
                    : value;
                  onFooterChange(originalRate, "serviceCharge");
                }}
                style={{ width: "100%" }}
              />
            </Col>
          </Flex>
        )}
        <Flex justify="space-between" align="center" gap={50}>
          <Col
            style={{
              width: "50%",
            }}
          >
            <Text
              level={5}
              style={
                {
                  // fontWeight: 500,
                }
              }
            >
              Grand Total :
            </Text>
          </Col>
          <Col
            style={{
              width: "19%",
            }}
          >
            <Text
              level={5}
              style={
                {
                  // fontWeight: 500,
                }
              }
            >
              {symbol}
              {parseFloat(
                conversionRate ? grandTotal * conversionRate : grandTotal || 0
              )?.toFixed(2)}
            </Text>
          </Col>
        </Flex>
        <Flex justify="space-between" align="center" gap={50}>
          <Col
            style={{
              width: "50%",
            }}
          >
            <Text
              level={5}
              style={
                {
                  // fontWeight: 500,
                }
              }
            >
              Paid Amount :
            </Text>
          </Col>
          <Col
            style={{
              width: "19%",
            }}
          >
            <InputNumberField
              min={0}
              data-testid="paid-amount-input"
              // Sales: Paid Amount is derived from the Payment section (payCart);
              // typing it manually only causes a mismatch at save time.
              disabled={pageType === "sales"}
              precision={2}
              value={parseFloat(
                conversionRate
                  ? footerValues?.paidAmount * conversionRate
                  : footerValues?.paidAmount
              )?.toFixed(2)}
                            onFocus={() => {
                if (Number(footerValues?.paidAmount) === 0) {
                  onFooterChange("", "paidAmount");
                }
              }}
              onChange={(value) => {
                const originalRate = conversionRate
                  ? value / conversionRate
                  : value;
                onFooterChange(originalRate, "paidAmount");
              }}
              style={{ width: "100%" }}
            />
          </Col>
        </Flex>
        <Flex justify="space-between" align="center" gap={50}>
          <Col
            style={{
              width: "50%",
            }}
          >
            <Text
              level={5}
              style={
                {
                  // fontWeight: 500,
                }
              }
            >
              Due Amount :
            </Text>
          </Col>
          <Col
            style={{
              width: "19%",
            }}
          >
            <Text
              level={5}
              style={
                {
                  // fontWeight: 500,
                }
              }
            >
              {symbol}
              {parseFloat(
                conversionRate
                  ? effectiveDueAmount * conversionRate
                  : effectiveDueAmount
              )?.toFixed(2)}
            </Text>
          </Col>
        </Flex>
        {effectiveDueAmount > 0 && dueDate && (
          <Flex justify="space-between" align="center" gap={50}>
            <Col
              style={{
                width: "50%",
              }}
            >
              <Text
                level={5}
                style={
                  {
                    // fontWeight: 500,
                  }
                }
              >
                Due Date :
              </Text>
            </Col>
            <Col
              style={{
                width: "19%",
              }}
            >
              <DatePicker
                value={getDueDateValue(dueDate)}
                onChange={(date) =>
                  onFooterChange(
                    date ? date.format("YYYY-MM-DD") : null,
                    "dueDate"
                  )
                }
                format="DD/MM/YYYY"
              />

            </Col>
          </Flex>
        )}

        <Flex justify="space-between" align="center" gap={50}>
          <Col
            style={{
              width: "100%",
            }}
          >
            <Text
              level={5}
              style={
                {
                  // fontWeight: 500,
                }
              }
            >
              Description
            </Text>
            <Input.TextArea
              value={footerValues?.description}
              onChange={(e) => {
                onFooterChange(e.target.value, "description");
              }}
              // Flex={2}
              style={{ width: "100%" }}
            />
          </Col>
        </Flex>
        <Flex>
          <Col
            style={{
              width: "100%",
            }}
          >
            <Text
              level={5}
              style={
                {
                  // fontWeight: 500,
                }
              }
            >
              Challan Text
            </Text>
            <Input.TextArea
              value={footerValues?.challanText}
              onChange={(e) => onFooterChange(e.target.value, "challanText")}
              rows={2}
              style={{ width: "100%" }}
            />
          </Col>
        </Flex>
      </Flex>
      {/* <style>
        {`
  @media (min-width: 768px) {
    .responsive-grid {
      grid-template-columns: 1fr 1fr !important;
    }
  }
`}
      </style> */}
    </Flex>
  );
};

export default DataTableFooter;
